import React from 'react';
import {OrderFields} from "../types/fields";
import {hexToRGBA} from "../../../@core/utils/hex-to-rgba";
import CustomChip from "../../../@core/components/mui/chip";
import {CustomChipProps} from "../../../@core/components/mui/chip/types";
import {OrderOption, OrderViewDTO} from "../types/dto";
import {getOrderStatusColor} from "../types/typification";

interface OrderStatusChipProps extends CustomChipProps {
    orderOption: OrderOption,
    elevation?: number
}

function OrderStatusChip({orderOption, elevation, ...rest}:OrderStatusChipProps) {
    const color = getOrderStatusColor(orderOption[OrderFields.StatusCode]);

    return (
        <CustomChip
            label={orderOption[OrderFields.StatusDesc]}
            skin='light'
            sx={{
                p: 1,
                color: color,
                backgroundColor: hexToRGBA(color, 0.18),
                boxShadow: elevation,
                ...rest.sx
            }}
            size='small'
            {...rest}
        />
    );
}

export default OrderStatusChip;